<template>
	<transition name="cookie-notice">
		<div class="cookie-notice" v-if="show">
			<div class="container">
				<div class="content">
					<h4 class="headline">{{ headline }}</h4>
					<div class="body t-linkify" v-html="body" />
				</div>
				<div class="accept">
					<button class="button" @click="accept">
						{{ buttonLabel }}
					</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
const LS_COOKIE_KEY = "puori-cookie-accept";

export default {
	name: "CookieNotice",
	selector: "#vue-cookie",

	data() {
		return {
			show: true
		};
	},

	props: {
		headline: {
			type: String,
			required: true
		},
		body: {
			type: String,
			required: true
		},
		buttonLabel: {
			type: String,
			required: true
		}
	},

	methods: {
		accept() {
			localStorage.setItem(LS_COOKIE_KEY, "true");
			this.show = false;
		}
	},

	created() {
		this.show = localStorage.getItem(LS_COOKIE_KEY) !== "true";
	}
};
</script>

<style lang="scss" scoped>
.cookie-notice {
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	z-index: z-index(cookie);
	background-color: $white;
	box-shadow: 0 0 10px rgba(black, 0.1);

	&-enter-active,
	&-leave-active {
		transition: transform 0.2s ease-in-out;
	}

	&-enter,
	&-leave-to {
		transform: translateY(100%);
	}
}

.headline {
	margin: 0;
	font-size: 22px;
}

.container {
	@include outer-container;
	padding-top: 16px;
	padding-bottom: 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@include media("<=tablet") {
		display: block;
	}
}

.content {
	width: 50%;

	@include media("<=tablet") {
		width: 100%;
	}
}

.accept {
	/* text-align: right; */
	@include media("<=tablet") {
		margin-top: 32px;
		text-align: center;
	}
}
</style>